import React, {useState, useEffect} from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {Servers, Users, FakeDetected, NonStopWork} from '../../../assets';

const list = [
  {
    id: '1',
    title: 'Two-Factor Authentication (2FA)',
    text: 'Double your server`s security. Activate 2FA for an extra layer of protection.',
  },
  {
    id: '2',
    title: 'End-to-end encryptedv',
    text: 'Because of advanced cryptography, no one else - not even our team - can read your data.',
  },
  {
    id: '3',
    title: 'Transparent pricing',
    text: 'No credit cards, no hidden payments. You pay for what you get and even more!',
  },
];

const data = [
  {
    id: '1',
    title: 'Servers',
    quantity: 'guilds',
    icon: <Servers />,
  },
  {
    id: '2',
    title: 'Users',
    quantity: 'members',
    icon: <Users />,
  },
  {
    id: '3',
    title: 'Fakes Detected',
    quantity: 'detected',
    icon: <FakeDetected />,
  },
  {
    id: '4',
    title: 'Days of Work',
    quantity: 'workDays',
    icon: <NonStopWork />,
  },
];

export const Trusted = ({stats}) => {
  return (
    <div className={styles.trusted}>
      <div className={styles.container}>
        <p className={styles.slogan}>Security 🤝 Convenience</p>
        <h3 className={styles.title}>Trusted by many</h3>
        <p className={styles.subTitle}>Safety and quality are the raison d'être of our products</p>
        <div className={styles.dataWrapper}>
          <div className={styles.data}>
            {data.map((item) => (
              <DataComponent
                key={item.id}
                title={item.title}
                icon={item.icon}
                id={item.id}
                quantity={stats[item.quantity] || 0}
              />
            ))}
          </div>
        </div>
        <div className={styles.listInfo}>
          {list.map((item) => (
            <div key={item.id} className={styles.item}>
              <p className={styles.itemTitle}>{item.title}</p>
              <p className={styles.itemText}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const DataComponent = ({title, quantity, icon, id}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const startCount = 0;
    const duration = 5000;

    const startTime = Date.now();

    const updateCount = () => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime;

      if (elapsedTime >= duration) {
        setCount(quantity);
        clearInterval(intervalId);
      } else {
        const progress = (elapsedTime / duration) * 100;
        const newCount = Math.floor((progress / 100) * (quantity - startCount) + startCount);
        setCount(newCount);
      }
    };

    const intervalId = setInterval(updateCount, 16);

    return () => clearInterval(intervalId);
  }, [quantity]);

  return (
    <div key={id} className={styles.dataItem}>
      <div
        className={clsx(styles.dataIcon, {
          [styles.red]: id === '1',
          [styles.green]: id === '2',
          [styles.blue]: id === '3',
          [styles.purple]: id === '4',
        })}>
        {icon}
      </div>
      <div className={styles.dataInfo}>
        <p className={styles.dataTitle}>{title}</p>
        <p className={styles.dataQuantity}>{count}</p>
      </div>
    </div>
  );
};
